import { makeAutoObservable } from "mobx";
import {
    deleteStockOutFromEMR,
    getStockOutById,
    pagingStockOutFromEMR,
    saveOrUpdate,
} from 'app/services/StockOutFromEMRService';
import { SearchStockOut } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { checkSearchObject } from "app/common/LocalFunction";
import { StockOut } from "app/common/Model/StockOut";
import { confirmStockOutFromEMR } from "app/services/StoreHubService";

export default class StockOutStore {
    listAllStockOut = [];
    searchStockOut = new SearchStockOut();
    pageStockOut = null;
    selectedStockOut = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingStockOutFromEMR = async () => {
        return await pagingStockOutFromEMR(this.searchStockOut)
            .then(({ data }) => {
                this.pageStockOut = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchStockOut) => {
        this.searchStockOut = checkSearchObject(this.searchStockOut, searchStockOut);
        this.pagingStockOutFromEMR();
    }

    handleOpenFormCreateOrEdit = (stockOutId) => {
        if (Boolean(stockOutId)) {
            getStockOutById(stockOutId).then(({ data }) => {
                this.selectedStockOut = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedStockOut = new StockOut();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdate = (stockOut) => {
        saveOrUpdate(stockOut)
            .then(() => {
                // this.selectedStockOut = null;
                toast.success("Lưu phiếu thành công!");
                // this.handleClosePopup();
                this.pagingStockOutFromEMR();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu phiếu có lỗi");
            })
    }
    confirmStockOutFromEMR = (storeRequest) => {
        confirmStockOutFromEMR(storeRequest)
            .then(() => {
                this.selectedStockOut = null;
                toast.success("Gửi yêu cầu thành công!");
                this.handleClosePopup();
                this.pagingStockOutFromEMR();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Gửi yêu cầu có lỗi");
            })
    }

    
    handleDelete = (stockOut) => {
        this.selectedStockOut = { id: stockOut?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteStockOutFromEMR(this.selectedStockOut?.id)
            .then(() => {
                if (this.searchStockOut?.pageIndex > 1 && this.pageStockOut?.content?.length === 1) {
                    this.searchStockOut.pageIndex -= 1;
                }
                toast.success("Xóa phiếu thành công!");
                this.handleClosePopup();
                this.pagingStockOutFromEMR();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa phiếu có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchStockOut = new SearchStockOut();
        this.pageStockOut = null;
        // this.selectedStockOut = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }
    resetValueStore = () => {
        this.selectedStockOut = null;
    }

    
}
